import Constants from '@/Constants';
import { closeChatModal } from '@/store/bot/actions';
import { LocaleData } from '@/translations/LocaleData';
import React from 'react';
import { useDispatch } from 'react-redux';

interface HeaderProps {
    avatar: string;
    strings: LocaleData;
}

const ChatHeader: React.FC<HeaderProps> = (props: HeaderProps) => {
    const { avatar, strings } = props;
    const dispatch = useDispatch();

    return (
        <div className="chat-modal-header">
            <div className="avatar">
                <img src={avatar} />
                <span className="status"></span>
            </div>
            <div className="title">
                <span>{strings.BOT_NAME}</span>
                <span className="sub-title">{strings.BOT_AVAILABILITY}</span>
            </div>
            <i
                className="close-button material-icons"
                onClick={() => {
                    dispatch(closeChatModal());
                }}
            >
                {' '}
                {Constants.icons.CLOSE}
            </i>
        </div>
    );
};

export default ChatHeader;
